import styled, { css } from 'styled-components';
import { Label } from '../../Label/Label';
import type {
  TabSelectorStyledProps,
  TabSelectorOptionStyledProps,
  TabLabelStyledProps,
} from './TabSelectorOption.typed';

const getOptionSelectedStyles = () => css`
  color: #333333;
  cursor: default;
  font-weight: 700;
`;

const getDisabledStyles = () => css`
  background: #f2f2f2;
`;

const getErrorStyles = () => css`
  border-color: #cc2324;
`;

const TabSelectorOption = styled.div<TabSelectorOptionStyledProps>((props) => {
  const { hasError, disabled } = props;

  return css`
    flex: 1;
    ${hasError && !disabled && getErrorStyles()}
    ${disabled && !hasError && getDisabledStyles()};
  `;
});

const TabSelector = styled.div<TabSelectorStyledProps>((props) => {
  const { hasError, disabled } = props;

  return css`
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
    gap: 8px;

    @media only screen and (min-width: ${({ theme }) =>
        theme.breakpoints.md}px) {
      gap: 16px;
    }

    ::-webkit-scrollbar {
      width: 0;
      height: 0;
      background-color: transparent;
    }

    ${hasError && !disabled && getErrorStyles()}
    ${disabled && !hasError && getDisabledStyles()}
  `;
});

const TabLabel = styled(Label)<TabLabelStyledProps>`
  display: flex;
  justify-content: center;
  position: relative;

  color: #666666;

  font-size: 16px;
  line-height: 24px;
  min-width: 112px;

  transition: left 200ms ease-in-out 0s;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 18px;
    line-height: 24px;
  }

  ${({ selected }) => selected && getOptionSelectedStyles()}
`;

const TabInput = styled.input<{ checked?: boolean }>`
  appearance: none;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &:not(:focus-visible) {
    border-bottom: ${({ checked }) => (checked ? '2px solid #333333' : '')};
    border-radius: 0px;
  }

  &:focus-visible {
    opacity: 1;
    outline: none;
    border: 2px solid #333333;
    border-radius: 4px;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const Content = styled.div`
  padding: 8px 0;
`;

export { TabSelector, TabSelectorOption, TabLabel, TabInput, Content };
